import Privacy from "./Privacy.page";

export default Privacy;
